import Vue from 'vue'
import VConsole from 'vconsole'
import App from './App.vue'
import router from './router'
import store from './store'
import jslogin from '@lyh/jslogin'
import jssdk from '@/assets/js/wx'
import { wxshare } from '@/assets/js/wxshare.js'
import appshare from '@/assets/js/appshare.js'
import SharePicker from '@/components/sharePicker'
import { is_app } from '@lyh/jsbridge'
import '@lyh/jsbridge'
window.setupWebViewJavascriptBridge(() => {}) //安装jsbridge

Vue.config.productionTip = false

import '@/assets/css/init.less'
import '@/api'
import '@/plugins/vant'

Vue.prototype.$rundev = 'H5'

if (navigator.userAgent.indexOf('AliApp') > -1) {
  Vue.prototype.$rundev = 'Aliapp'
}

if (navigator.userAgent.indexOf('miniProgram') > -1 || navigator.userAgent.indexOf('MicroMessenger') > -1) {
  Vue.prototype.$rundev = 'WX'
  jssdk()

  Vue.prototype.$wxshare = wxshare
  Vue.prototype.$SharePicker = SharePicker
}

if (is_app()) {
  Vue.prototype.$SharePicker = SharePicker
  Vue.prototype.$appshare = appshare
  sessionStorage.setItem('LYH_JSLOGIN_SOURCE', 1000)
}

if (process.env.VUE_APP_TYPE == 0) {
  new VConsole()
}

new Vue({
  router,
  store,
  jslogin,
  render: (h) => h(App)
}).$mount('#app')
